import { useApiClient } from '../../hooks/useApiClient';
import { EnqueueJob } from '../../types/Job/EnqueueJob.type';
import { Job } from '../../types/Job/Job.type';

export const useJobApi = () => {
  const apiClient = useApiClient();

  return {
    getJobs: (): Promise<Job[]> => apiClient('/jobs/'),

    getJob: (jobId: number): Promise<Job> => apiClient(`/jobs/${jobId}`),

    enqueueJob: (data: EnqueueJob): Promise<Job> =>
      apiClient('/jobs/enqueue', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  };
};
